import { render } from "./JobDetail.vue?vue&type=template&id=11f79940&scoped=true"
import script from "./JobDetail.vue?vue&type=script&lang=js"
export * from "./JobDetail.vue?vue&type=script&lang=js"

import "./JobDetail.vue?vue&type=style&index=0&id=11f79940&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11f79940"]])

export default __exports__